import { render, staticRenderFns } from "./c-select-chip.vue?vue&type=template&id=81c784d2&"
import script from "./c-select-chip.vue?vue&type=script&lang=js&"
export * from "./c-select-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports